export function resetFormPristineIfAllFieldsAreValid(form: angular.IFormController): void {
    if (form.$dirty) {
        let haveDirtyProperty = false;
        Object.keys(form).forEach(key => {
            if (key[0] !== '$' && form[key].$setDirty) {
                if (form[key].$dirty) {
                    haveDirtyProperty = true;
                }
            }
        });
        if (!haveDirtyProperty) {
            form.$setPristine();
        }
    }
}